import FItemString from '../FItem/String';
import component from './component.vue';

export default class FInput extends FItemString {
  __component = component;
}
